import { render, staticRenderFns } from "./HmwSlide.vue?vue&type=template&id=348dd5b0&scoped=true"
import script from "./HmwSlide.vue?vue&type=script&lang=js"
export * from "./HmwSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348dd5b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348dd5b0')) {
      api.createRecord('348dd5b0', component.options)
    } else {
      api.reload('348dd5b0', component.options)
    }
    module.hot.accept("./HmwSlide.vue?vue&type=template&id=348dd5b0&scoped=true", function () {
      api.rerender('348dd5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/HmwSlide.vue"
export default component.exports